/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-gps': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.89.354a.387.387 0 0 0-.44-.082L.227 9.095a.388.388 0 0 0 .097.734l8.623 1.445.986 8.149a.388.388 0 0 0 .732.125L19.96.796a.387.387 0 0 0-.07-.442zm-9.345 17.689l-.864-7.15a.388.388 0 0 0-.32-.335L1.693 9.273l17.086-7.84z" _fill="#6ca2ca"/>'
  }
})
